/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { BaseController } from './BaseController';

class ListController extends BaseController {
    $onInit() {
        super.$onInit();

        this.filters = [];
        this.paging = {
            page: 1,
            size: this.configuration.DEFAULT_PAGE_SIZE
        };
        this.limitOptions = this.configuration.PAGE_SIZE_OPTIONS;
        this.model = {
            data: [],
            page: {}
        };
    }
}

export { ListController };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/ListController.js